<template>
  <div class="title">
    <div class="title-label">
      <span class="text">{{ label || '人员排行' }}</span>
      <!-- 媒体分布不显示 -->
      <i v-show="!label.includes('媒体')" class="top-30">Top30</i>
    </div>

    <div class="filters">
      <ElForm class="elementui-common-form-styles" v-highlight ref="formInline" :model="form" inline>
        <ElFormItem>
          <slot :form="form"></slot>
        </ElFormItem>

        <ElFormItem v-if="!label.includes('媒体')">
          <el-select v-model="form.sort" style="width: 90px" size="small" @change="$emit('sort-type-change')">
            <el-option v-for="item in rankItems" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem v-else>
          <slot name="slot1" :form="form"></slot>
        </ElFormItem>

        <ElFormItem label-width="0">
          <el-select v-model="form.dateType" style="width: 80px" size="small" @change="$emit('date-type-change')">
            <el-option v-for="date in dateRanges" :key="date.value" :label="date.label" :value="date.value"> </el-option>
          </el-select>
        </ElFormItem>

        <el-button icon="el-icon-refresh" @click="$emit('sort-type-change')">刷新</el-button>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { rankItems, dateRanges } from '../../consts/index.js'

export default {
  props: ['label', 'form'],
  computed: {
    dateRanges() {
      return dateRanges
    },
    rankItems() {
      return rankItems
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: space-between;
  .title-label {
    .text {
      font-size: 18px;
      margin: 12px 0;
      font-weight: 600;
    }
    .top-30 {
      font-size: 16px;
      color: #ffa300;
      margin-left: 10px;
      font-weight: 600;
    }
  }
}
</style>
